import React from 'react';

const Footer = () => (
  <footer className="bg-[#f8fafc] border-t border-gray-200 py-8 mt-12">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="text-center md:text-left">
        <a href="/" className="text-2xl font-bold text-[#618A3D] hover:text-[#75a64b] transition no-underline" style={{ textDecoration: 'none' }}>Imaginex</a>
        <p className="text-gray-600 mt-2 text-sm">Empowering small businesses with modern technology and design.</p>
      </div>
      <nav className="flex flex-col sm:flex-row gap-4 text-center md:text-right">
        <a href="/About" className="text-gray-700 hover:text-[#618A3D] font-medium transition">About</a>
        <a href="/webdev" className="text-gray-700 hover:text-[#618A3D] font-medium transition">Website Development</a>
        <a href="/ai" className="text-gray-700 hover:text-[#618A3D] font-medium transition">AI Solutions</a>
        <a href="/marketing" className="text-gray-700 hover:text-[#618A3D] font-medium transition">Social Media Marketing</a>
                            <a href="mailto:theimaginexcompany@gmail.com" className="text-gray-700 hover:text-[#618A3D] font-medium transition">Contact</a>
      </nav>
    </div>
    <div className="mt-8 text-center text-xs text-gray-400">&copy; {new Date().getFullYear()} Imaginex. All rights reserved.</div>
  </footer>
);

export default Footer;
